import { createApp } from "vue";
import App from "./App.vue";
import "../src/assets/style/custom.css";
import "../src/assets/scss/nestview.css";
import "../src/assets/tailwind.css";
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import router from "./router";
import Store from "./store/Store";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import "font-awesome/css/font-awesome.min.css";
import "../node_modules/nprogress/nprogress.css";
import "./store/axios.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import 'driver.js/dist/driver.css';
import '../src/assets/style/tour.css';
// main.js
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'jquery'
import 'slick-carousel'
import helper from './helpers/helperFunction.js';
// ✅ Create app first
const app = createApp(App);

// ✅ THEN register Font Awesome
library.add(fas, fab);
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.use(helper);
app.use(Store);
app.use(VueViewer);
app.use(VCalendar, {});
app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
  },
});

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const activeToastIds = new Set();
const options = {
  filterBeforeCreate(toast, toasts) {
    const id = toast.content;

    // Already shown? Don't show again
    if (activeToastIds.has(id)) {
      return false;
    }

    // Add to active set
    activeToastIds.add(id);

    // Hook into onClose to clean up
    const originalOnClose = toast.onClose;
    toast.onClose = () => {
      activeToastIds.delete(id);
      if (typeof originalOnClose === 'function') {
        originalOnClose();
      }
    };

    return toast;
  },

  // optional
  position: 'top-right',
  timeout: 2000,
  maxToasts: 1,
  newestOnTop: true,
};
app.use(Toast, options);

app.config.devtools = true;

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
app.use(VueSweetalert2);

import Modal from "./plugins/FDialog.js";
app.use(Modal);
import ConfirmationDialog from "./plugins/ConfirmationDialog.js";
app.use(ConfirmationDialog);
import FLoader from "./plugins/FLoader.js";
app.use(FLoader);

import VueSignaturePad from 'vue-signature-pad';
app.use(VueSignaturePad);

import { install } from "vue3-recaptcha-v2";

app.use(install, {
  sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  cnDomains: false, // Optional, If you use in China, set this value true
})

const globals = app.config.globalProperties;
export { globals };

app.mount("#app");
